<template>
  <div :style="{ margin: '2rem' }">
    <DialogLoading
      :message="loadingMessage"
      :active="loading"
    />
    <ConfirmationModal
      :active="confirmModal"
      :handleConfirm="handleAcceptConfirmModal"
      :handleCancel="handleCancelConfirmModal"
      title="Credor Resolvido"
      message="Você tem certeza que deseja marcar o credor como resolvido?"
    />
    <v-card>
      <v-data-table
        :headers="headers"
        :items="creditors"
        :page.sync="page"
        :items-per-page="itemsPerPage"
        @page-count="pageCount = $event"
        :disable-sort="true"
        :loading="loading"
        loading-text="Carregando... Por favor, aguarde"
        no-data-text="Nenhum credor encontrado"
        hide-default-footer
      >
        <template v-slot:top>
          <v-toolbar flat color="white">
            <v-toolbar-title class="title-bold">Credores não sincronizados no Sienge</v-toolbar-title>
            <v-spacer></v-spacer>
          </v-toolbar>
        </template>
        <template v-slot:[`item.name`]="{ item }">
         {{ item.client ? item.client.name : '' }}
        </template>
        <template v-slot:[`item.actions`]="{ item }">
          <v-icon
            @click="openConfirmModal(item)"
          >
            mdi-chevron-down-circle-outline
          </v-icon>
        </template>
        <template v-slot:no-data>
          Sem dados
        </template>
      </v-data-table>
      <div class="text-center pt-2">
      <v-pagination v-model="page" :length="pageCount"></v-pagination>
    </div>
    </v-card>
  </div>
</template>

<script>
import DialogLoading from '@/components/loading/DialogLoading'
import ConfirmationModal from '@/components/modals/ConfirmationModal'
import message from '@/utils/message'
import api from '@/services/api'

export default {
  components: {
    DialogLoading,
    ConfirmationModal
  },

  data: () => ({
    itemToFinish: null,
    confirmModal: false,
    dialog: false,
    loading: true,
    loadingMessage: 'Carregando',
    page: 1,
    pageCount: 0,
    itemsPerPage: 10,
    headers: [
      { text: 'Cliente', align: 'start', value: 'name' },
      { text: 'Descrição', value: 'description' },
      { text: 'Ações', value: 'actions', sortable: false }
    ],
    creditors: [],
    editedIndex: -1
  }),

  created () {
    this.getCreditors()
  },

  methods: {
    async getCreditors () {
      try {
        this.loading = true
        const { data } = await api.get('/creditors')
        this.creditors = data
      } catch (error) {
        message.error('Erro ao buscar credores')
      } finally {
        this.loading = false
      }
    },

    async finished () {
      try {
        this.loading = true
        await api.put(`/creditors/${this.itemToFinish.id}`)
        const index = this.creditors.indexOf(this.itemToFinish)
        this.creditors.splice(index, 1)
        message.success('Credor Resolvido')
      } catch (error) {
        message.error('Erro na operação')
      } finally {
        this.loading = false
      }
    },

    handleCancelConfirmModal () {
      this.confirmModal = false
    },

    handleAcceptConfirmModal () {
      this.confirmModal = false
      this.finished()
    },

    openConfirmModal (item) {
      this.itemToFinish = item
      this.confirmModal = true
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/creditors/SiengeCreditors.vue